module.exports = __webpack_public_path__ + "static/media/solution-tube-kplusfull-closed.3984a893.svg";